import { useQuery } from '@tanstack/react-query';
import { getLiquidityRewards } from '../lib/apiClient';

// The logger runs every minute; the page doesn't need to follow it that closely.
const STALE_TIME_MS = 2 * 60_000;

/** Kalshi liquidity-rewards census. Hypothetical only. */
export function useLiquidityRewards() {
  return useQuery({
    queryKey: ['liquidity-rewards'],
    queryFn: getLiquidityRewards,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
